import { FunctionComponent } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCookies } from "react-cookie";

import {
  StyledBoxArea,
  StyledPageTitle,
  StyledContainer,
  StyledDescription,
  BackToHomepageButton,
  IconStyled,
} from "./styles";

import { PageContainer } from "containers/PageContainer/styles";
import { sendULFEvent } from "state/config-slice";
import { ULFEvents } from "types/ULF";
import Basket from "components/IconImage/basket";

const NotFound: FunctionComponent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [cookies] = useCookies();

  return (
    <PageContainer>
      <StyledContainer>
        <IconStyled>
          <Basket stroke="#CCCCCC" width="100px" height="90px" />
        </IconStyled>

        <StyledPageTitle>
          <Trans i18nKey="This page doesn't exist" />
        </StyledPageTitle>
        <StyledDescription>
          <Trans i18nKey="Please go back to the homepage" />
        </StyledDescription>

        <StyledBoxArea>
          <BackToHomepageButton
            id="not-found-back"
            onClick={() => {
              navigate("/");
              dispatch(
                sendULFEvent({
                  "event-name": ULFEvents.REDIRECT_TO_HOME_PAGE,
                  page: window.location.pathname,
                  source: cookies.SOURCE,
                  isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
                }),
              );
            }}
            title={t("Back to homepage")}
          />
        </StyledBoxArea>
      </StyledContainer>
    </PageContainer>
  );
};

export default NotFound;
